export enum DoorSize {
    Indeterminate = 0,
    Custom = 1,
    Storm_30x74 = 2,
    Storm_30x76 = 3,
    Storm_30x78 = 4,
    Storm_30x81 = 5,
    Storm_32x74 = 6,
    Storm_32x75 = 7,
    Storm_32x76 = 8,
    Storm_32x78 = 9,
    Storm_32x81 = 10,
    Storm_32x96 = 11,
    Storm_34x78 = 12,
    Storm_34x81 = 13,
    Storm_36x74 = 14,
    Storm_36x78 = 15,
    Storm_36x81 = 16,
    Storm_36x96 = 17,
    Storm_36x85 = 18,
    Security_36x80 = 19,
    Security_36x81 = 20,
    Security_36x96 = 21,
    Security_32x80 = 22,
    Security_32x81 = 23,
    Security_30x80 = 24,
    Security_30x81 = 25,
    Security_30x78 = 26,
    Security_32x78 = 27,
    Security_34x81 = 28,
    Security_36x84 = 29,
    Pet_XSmall = 30,
    Pet_Small = 31,
    Pet_Medium = 32,
    Pet_Large = 33,
    Pet_XLarge = 34,
    Storm_Installation = 35,
}

